import React from "react";
import SweetAlert from "react-bootstrap-sweetalert";

export const confirmButtonType = Object.freeze({
  Primary: "primary",
  Danger: "danger",
  Success: "success",
});

const DeleteConfirmationDialog = ({
  show,
  warning = true,
  focusCancelBtn = true,
  title,
  message,
  onConfirm,
  onCancel,
  confirmBtnText,
  confirmBtnBsStyle,
  cancelBtnBsStyle,
}) => {
  return (
    <SweetAlert
      warning={warning}
      showCancel
      confirmBtnText={confirmBtnText || "Yes, delete it!"}
      confirmBtnBsStyle={confirmButtonType[confirmBtnBsStyle] || "danger"}
      title={title}
      onConfirm={onConfirm}
      onCancel={onCancel}
      cancelBtnBsStyle={confirmButtonType[cancelBtnBsStyle] || "default"}
      focusCancelBtn={focusCancelBtn}
      show={show}
    >
      {message}
    </SweetAlert>
  );
};

export default DeleteConfirmationDialog;
